import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import ButtonDownload from '../../Buttons/ButtonDownload/ButtonDownload';

const subscriptionUnlimited = (props) => {
  return (
    <div className='subscriptionUnlimited'>
      <div className='text-bordered'>
        המנוי {props.selectedSubscriber.cli} הינו מנוי לשירות המתנה נעימה <span>ללא הגבלה</span>
      </div>
      <div className='text-no-charge'>
        <Image src={require('../images/icon-v.svg')} alt='איקון V' />
        <span>הורדת שיר זה הינה ללא עלות</span>
      </div>
      <div className='btn-song-download-holder'>
        <ButtonDownload text='הורדה' onclick={() => props.downloadSong()} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedSubscriber: state.fundialPage.selectedSubscriber,
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(subscriptionUnlimited);